export const UPDATE_APPLE_PAY_SUPPORTED_DEVICE = 'UPDATE_APPLE_PAY_SUPPORTED_DEVICE';
export const UPDATE_SUPPORTED_DIGITAL_PROVIDER = 'UPDATE_SUPPORTED_DIGITAL_PROVIDER';
